export default __webpack_public_path__ + "static/media/Circle_Blood.129526a9.png";